import React, { useState, useCallback, useRef } from "react";
import HomePage from "../Pages/HomePage/HomePage";
import {
  makeStyles,
  Grid,
  ClickAwayListener,
  Portal,
  Typography,
} from "@material-ui/core/";
import ScrollDownAppBar from "../Components/ScrollDownAppBar/ScrollDownAppBar";
import WebAppBar from "../Components/WebAppBar/WebAppBar";
import BottomPart from "../Components/BottomPart/BottomPart";
import LoginPage from "../Pages/LoginPage/LoginPage";
import fire from "../Pages/LoginPage/fire";
import ExperiencePage from "../Pages/ExperiencePage/ExperiencePage";
import OnlExperiencePage from "../Pages/OnlExperiencePage/OnlExperiencePage";
import InputInfor from "../Components/InputInfor/InputInfor";
import { useLoadScript } from "@react-google-maps/api";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
const libraries = ["places"];
function Admin(props) {
  const useStyles = makeStyles((theme) => ({
    Main: {
      maxWidth: "1920px",
      margin: "0 auto",
      overflow: "hidden",
      backgroundColor: "white",
      position: "absolute",
      top: 60,
      left: 0,
      right: 0,
    },
    body: {
      maxWidth: "1920px",
      margin: "0 auto",
      position: "relative",
      top: 0,
      left: 0,
    },
    News: {
      maxWidth: "1920px",
      margin: "0 auto",
      overflow: "hidden",
      padding: "0 6%",
      height: 60,
      backgroundColor: "black",
      textAlign: "center",
      color: "white",
    },

    SDAppBarDiv: {
      zIndex: 100,
      position: "fixed",
      width: "100%",
      top: "-50vh",
      left: 0,
      right: 0,
      color: "white",
      transition: "top 0.6s",
      maxWidth: "1920px",
      margin: "0 auto",
      transitionTimingFunction: "ease-in-out",
    },
    AppBarInput: {
      height: "auto",
      zIndex: 99,
      maxWidth: "1920px",
      position: "relative",
      margin: "20px auto auto auto",
      top: 0,

      transition: "top 0.6s",
      transitionTimingFunction: "ease-in-out",
    },
    BottomPartDiv: {
      padding: " 30px 6%",
      backgroundColor: "#f6f5f1",
      borderWidth: "1px 0 0 0",
      borderColor: "#bbbfca",
      borderStyle: "solid",
    },
  }));
  const classes = useStyles();

  useEffect(() => {
    const checkScrollState = () => {
      if (window.pageYOffset > 60) {
        document.getElementById("SDAppBarDiv").style.top = 0;
        document.getElementById("AppBarInput").style.top = "-50vh";
      } else {
        document.getElementById("SDAppBarDiv").style.top = "-50vh";
        document.getElementById("AppBarInput").style.top = 0;
      }
    };

    window.addEventListener("scroll", checkScrollState);

    return () => {
      window.removeEventListener("scroll", checkScrollState);
    };
  }, []);
  // used for suggetion
  
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });

  if (loadError) return "Error loading maps";
  if (!isLoaded) return "Loading Maps";

  return (
    <div>
      <Grid
        className={classes.News}
        container
        justify="center"
        alignItems="center"
      >
        Thông tin mới nhất về Covid-19
      </Grid>

      <div id="SDAppBarDiv" className={classes.SDAppBarDiv}>
        <ScrollDownAppBar
          pageStyle={{
            padding: "0 6%",
            backgroundColor: "white",
            boxShadow: "0px -5px 20px 0px #888888",
          }}
          logoColor={{ color: "#fd3a69" }}
          color={"#393e46"}
          scrollDownAppBar={true}
        />
      </div>
      <div id="AppBarInput" className={classes.AppBarInput}>
        <ScrollDownAppBar
          pageStyle={{
            padding: "0 6%  3% 6%",
            color: "white",
          }}
          logoColor={{ color: "white" }}
          linkColor={{ color: "white" }}
          color={"white"}
          scrollDownAppBar={false}
        />
      </div>
      <div className={classes.Main}>
        <Switch>
          <Route path="/" exact component={HomePage} />
          <Route path="/experience" component={ExperiencePage} />
          <Route path="/onlExperience" component={OnlExperiencePage} />
        </Switch>

        <div className={classes.BottomPartDiv}>
          <BottomPart />
        </div>
      </div>
    </div>
  );
}

export default Admin;
